const currentPath: string = window.location.pathname;
const [{ title: postTitle, path: postPath }] = window.blogRef.filter(
  ({ path, shortcutPaths }) =>
    path === currentPath || shortcutPaths.includes(currentPath)
);
const suggestCorrectionLink: HTMLElement = document.getElementById(
  "suggest-correction-link"
);
const correctionHref: string = suggestCorrectionLink.getAttribute("href");

// Add post data to correction link href
const hrefWithData: string = `${correctionHref}&title=${encodeURIComponent(
  postTitle
)}&path=${encodeURIComponent(postPath)}`;

// Update href
suggestCorrectionLink.setAttribute("href", hrefWithData);
